export const navListItems = [
  {
    id: 1,
    breadcrumbText: "Project Directory",
    headerText: "PROJECT DIRECTORY",
    navText: "Projects",
    path: "/",
  },
  {
    id: 2,
    breadcrumbText: "Upgrades",
    headerText: "Upgrades",
    navText: "Upgrades",
    path: "/upgrades",
  },
  {
    id: 3,
    breadcrumbText: "FAQ",
    headerText: "Frequently Asked Questions",
    navText: "FAQ",
    path: "/faq",
  },
  {
    id: 4,
    breadcrumbText: "Contact Us",
    headerText: "Contact Us",
    navText: "Contact Us",
    path: "/contact-us",
  },
  {
    id: 5,
    breadcrumbText: "Alerts",
    headerText: "Alerts",
    navText: "Alerts",
    path: "/alerts",
  },
  {
    id: 6,
    breadcrumbText: "Settings",
    headerText: "Settings",
    navText: "Settings",
    path: "/settings",
  },
  {
    id: 7,
    breadcrumbText: "Insurtech Solutions",
    headerText: "Insurtech Solutions",
    navText: "Insurtech Solutions",
    path: "/insurtech-solutions",
  },
];
